// App.js

import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import Boletos from './components/boletos.js';
import Registro from './components/registro.js';
import Verificador from './components/verificador.js'; // 1. IMPORTAMOS EL COMPONENTE DE REGISTRO
import { Home, HelpCircle, Phone, CreditCard, Ticket, ArrowRight, Star, ChevronsRight, Search, CheckCircle, Clock, ShieldCheck, Ticket as TicketIcon } from 'lucide-react';
import { collection, addDoc, updateDoc, doc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';

// --- CONFIGURACIÓN DE FIREBASE (necesaria para guardar el registro) ---
const appId = typeof __app_id !== 'undefined' ? __app_id : 'default-raffle-app';
const firebaseConfig = {
  apiKey: "AIzaSyD3zTS6ijHH0_HsaNPtvDm-eIlyUw3x18o",
  authDomain: "rifas-el-pri.firebaseapp.com",
  projectId: "rifas-el-pri",
  storageBucket: "rifas-el-pri.firebasestorage.app",
  messagingSenderId: "1070599909067",
  appId: "1:1070599909067:web:6da522093d4a60c040b54e",
  measurementId: "G-1KC9D6VZY3"
};

// Firestore instance is imported from src/firebase.js (single shared initialization)


// --- COMPONENTE PLACEHOLDER ---
const AvisoDePrivacidad = ({ onBack }) => (
    <div className="fixed inset-0 bg-white z-50 p-8 overflow-y-auto">
        <button onClick={onBack} className="absolute top-4 right-4 text-gray-600">&times;</button>
        <h1 className="text-2xl font-bold mb-4">Aviso de Privacidad</h1>
        <p>Contenido del aviso de privacidad...</p>
    </div>
);


// --- FUNCIÓN DE UTILIDAD ---
const vibrateOnClick = () => {
    if (window.navigator && window.navigator.vibrate) {
        window.navigator.vibrate(50);
    }
};

// --- CONFIGURACIÓN PRINCIPAL ---
const CONFIG = {
    logoUrl: 'https://github.com/vordensports/vordensports/blob/main/chamanlogo123456.png?raw=true',
    ribbonUrl: 'https://github.com/vordensports/vordensports/blob/main/klipartz.com.png?raw=true',
    prizeImages: [
        'https://github.com/vordensports/vordensports/blob/main/1000011615.jpg?raw=true',
        'https://github.com/vordensports/vordensports/blob/main/1000011616.jpg?raw=true',
        'https://github.com/vordensports/vordensports/blob/main/1000011631.jpg?raw=true'
      
    ],
    prizeName: '¡Nissan Versa & Kia Rio! ¡Aparta tus boletos!',
    pdfUrl: 'https://www.jeep.com.mx/wrangler.html?utm_source=google-&utm_medium=paid-search&utm_campaign=renegade-brand-renegade-NACIONAL-T1&utm_term=performance-text-ad-cpc&utm_content=brand-showroom&gclsrc=aw.ds&gad_source=1&gad_campaignid=1751150801&gbraid=0AAAAAC1Ku771nuaDoCRLo9qc7oN7V9Hc8&gclid=CjwKCAjwr8LHBhBKEiwAy47uUhWmgnAxF3vY82R_RSeXfuTlLgzua6RZNGiOxCV_T0fh0s9cHxA2hhoCAjAQAvD_BwE',
    eventNumber: '1',
    totalTickets: 100,
    whatsappNumber: '524779231372',
    companyName: 'Rifas El Chaman',
    minutesToRelease: 30,
    paymentInfo: {
        bbvaAccounts: [
            { name: 'ARTURO MALDONADO LUNA', clabe: '012244004880510463', account: '0488051046' },
            { name: 'MCMS Proyectos y soluciones Sa de Cv', account: '0125074215', clabe: '012244001250742152' }
          
        ],
        banorteLogo: 'https://github.com/vordensports/vordensports/blob/main/Logo_de_Banorte.svg.png?raw=true',
        banorteAccounts: [
            { name: 'ARTURO MALDONADO LUNA', clabe: '072244013375940647', account: '1337594064' }
           
        ],
        santanderLogo: 'https://github.com/vordensports/vordensports/blob/main/Santander.png?raw=true',
        santanderAccounts: [
            { name: 'ARTURO MALDONADO LUNA', clabe: '014344655100176119', account: '65510017611' }
           
        ]
    },
    prices: [
        { count: 1, price: 100 },
        { count: 2, price: 200 },
        { count: 3, price: 300 },
        { count: 4, price: 400 },
        { count: 5, price: 400 },
    ],
    faqs: [
        { question: '¿CÓMO SE ELIGE A LOS GANADORES?', answer: 'Todos nuestros sorteos se realizan en base a la Lotería Nacional para la Asistencia Pública mexicana. El ganador de Rifas con causa el chaman será el participante cuyo número de boleto coincida con las últimas cifras del primer premio ganador de la Lotería Nacional (las fechas serán publicadas en nuestra página oficial).' },
        { question: '¿QUÉ SUCEDE CUANDO EL NÚMERO GANADOR ES UN BOLETO NO VENDIDO?', answer: 'Se elige un nuevo ganador realizando la misma dinámica en otra fecha cercana (se anunciará la nueva fecha). ¡Esto significa que tendrías el doble de oportunidades de ganar con tu mismo boleto!' },
        { question: '¿DÓNDE SE PUBLICA A LOS GANADORES?', answer: 'En nuestra página oficial de Facebook puedes encontrar todos y cada uno de nuestros sorteos anteriores, así como las transmisiones en vivo. Encuentra la transmisión en vivo de los sorteos en nuestra página de Facebook en las fechas indicadas a las 20:00 hrs CDMX. ¡No te lo pierdas!' }
    ],
    charity: {
        name: "Fundación Pro Niño Leonés A.C.",
        logoUrl: "https://difunda.org/wp-content/uploads/2022/07/Artboard-1.png"
    }
};

// --- COMPONENTES DE LA APLICACIÓN ---

const CloseIcon = ({ className }) => ( <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg> );

// MODIFICACIÓN 1: El componente Header ahora acepta 'onShowVerifier' como prop.
const Header = ({ onShowPayment, onShowTickets, scrollToSection, onShowVerifier }) => {
    const navLinkClasses = "flex items-center gap-2 text-black hover:text-green-600 font-semibold transition-colors";
    const handleNavClick = (action) => { vibrateOnClick(); action(); };

    return (
        <header className="fixed top-0 left-0 right-0 z-50 shadow-lg bg-white">
            <div className="bg-green-500 h-3"></div>
            <div className="relative h-24 flex items-center justify-center">
                 <div className="absolute left-1/2 -translate-x-1/2 top-1 h-28 w-28 bg-white rounded-full flex items-center justify-center shadow-md">
                   <img src={CONFIG.logoUrl} alt="Logo" className="h-24 object-contain" />
                </div>
                <nav className="container mx-auto px-4 sm:px-8 flex items-center justify-between h-full">
                    <div className="hidden md:flex items-center gap-8">
                         <a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick(() => scrollToSection('home')); }} className={navLinkClasses}><Home size={18} /> INICIO</a>
                         {/* MODIFICACIÓN 2: El onClick ahora llama a 'onShowVerifier', que es la función que pasamos desde App.js */}
                         <a href="#verifier" onClick={(e) => { e.preventDefault(); handleNavClick(onShowVerifier); }} className={navLinkClasses}>
                            <Search size={18} /> VERIFICAR BOLETO
                         </a>
                         <a href="#faq" onClick={(e) => { e.preventDefault(); handleNavClick(() => scrollToSection('faq')); }} className={navLinkClasses}><HelpCircle size={18} /> PREGUNTAS</a>
                    </div>
                     <div className="hidden md:flex items-center gap-4">
                        <button onClick={() => handleNavClick(onShowPayment)} className="bg-gray-100 text-black font-bold px-5 py-2.5 rounded-full hover:bg-gray-200 transition-all transform hover:scale-105 shadow-sm uppercase text-sm"><CreditCard size={16} className="inline mr-2"/>MÉTODOS DE PAGO</button>
                        <button onClick={() => handleNavClick(onShowTickets)} className="bg-green-500 text-white font-bold px-5 py-2.5 rounded-full hover:bg-green-600 transition-all transform hover:scale-105 shadow-sm uppercase text-sm"><Ticket size={16} className="inline mr-2"/>ADQUIRIR BOLETOS</button>
                    </div>
                    <div className="md:hidden flex w-full justify-between items-center">
                      <button onClick={() => handleNavClick(onShowPayment)} className="bg-gray-100 text-black font-bold px-3 py-2 rounded-lg text-xs uppercase shadow-sm">
                        MÉTODOS<br />DE PAGO
                      </button>
                      <button onClick={() => handleNavClick(onShowTickets)} className="bg-green-500 text-white font-bold px-3 py-2 rounded-lg text-xs uppercase shadow-sm">
                        ADQUIRIR<br />BOLETOS
                      </button>
                    </div>
                </nav>
            </div>
             <div className="bg-green-500 h-3"></div>
        </header>
    );
};

const PaymentMethods = ({ onBack }) => {
    const [paymentType, setPaymentType] = useState('bbva');

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex justify-center items-center p-4" onClick={() => { vibrateOnClick(); onBack(); }}>
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-lg text-center p-6 relative animate-fade-in-down" onClick={(e) => e.stopPropagation()}>
                <button onClick={() => { vibrateOnClick(); onBack(); }} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"><CloseIcon className="w-6 h-6" /></button>
                <img src={CONFIG.logoUrl} alt="Logo" className="w-24 h-22 mx-auto mb-4" />
                <h2 className="text-2xl font-sans-serif text-black mb-4">Métodos de pago (Puedes realizar transferencia o deposito.)</h2>
                <div className="flex flex-col sm:flex-row justify-center border-b mb-4 gap-4 items-center px-4">
                    <button onClick={() => setPaymentType('bbva')} className={`w-full sm:w-auto py-3 px-4 font-semibold transition-all flex items-center justify-center bg-white rounded-lg shadow-sm ${paymentType === 'bbva' ? 'ring-2 ring-blue-800' : 'text-gray-500'}`}>
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/BBVA_2019.svg/2560px-BBVA_2019.svg.png" alt="BBVA" className="h-8 mx-auto"/>
                    </button>
                    <button onClick={() => setPaymentType('banorte')} className={`w-full sm:w-auto py-3 px-4 font-semibold transition-all flex items-center justify-center bg-white rounded-lg shadow-sm ${paymentType === 'banorte' ? 'ring-2 ring-red-600' : 'text-gray-500'}`}>
                        <img src={CONFIG.paymentInfo.banorteLogo} alt="Banorte" className="h-10 mx-auto"/>
                    </button>
                </div>
                {paymentType === 'bbva' && (
                    <div className="text-left space-y-4 max-h-64 overflow-y-auto pr-2">
                        {CONFIG.paymentInfo.bbvaAccounts.map((acc, index) => (
                            <div key={index} className="bg-gray-100 p-3 rounded-lg border border-gray-200">
                                <p className="font-bold text-black">{acc.name}</p>
                                <p><span className="font-semibold text-gray-700">CLABE:</span> {acc.clabe}</p>
                                <p><span className="font-semibold text-gray-700">Cuenta:</span> {acc.account}</p>
                            </div>
                        ))}
                         <div className="mt-4 p-3 bg-yellow-100 text-yellow-800 rounded-lg text-sm">
                            <p className="font-semibold">Importante:</p>
                            <p>Si una cuenta está saturada, por favor intenta con otra. No olvides mandar tu comprobante de pago a nuestro WhatsApp.</p>
                        </div>
                    </div>
                )}
                {paymentType === 'banorte' && (
                     <div className="text-left space-y-4 max-h-64 overflow-y-auto pr-2">
                        {CONFIG.paymentInfo.banorteAccounts.map((acc, index) => (
                            <div key={index} className="bg-gray-100 p-4 rounded-lg border border-gray-200">
                                <p className="font-bold text-black">{acc.name}</p>
                                <p className="mt-1"><span className="font-semibold text-gray-700">CLABE:</span> <span className="text-gray-800">{acc.clabe}</span></p>
                                <p><span className="font-semibold text-gray-700">Cuenta:</span> <span className="text-gray-800">{acc.account}</span></p>
                            </div>
                        ))}
                         <div className="mt-4 p-3 bg-yellow-100 text-yellow-800 rounded-lg text-sm">
                            <p className="font-semibold">Importante:</p>
                            <p>Si una cuenta está saturada, por favor intenta con otra. No olvides mandar tu comprobante de pago a nuestro WhatsApp.</p>
                        </div>
                     </div>
                )}
                {/* Santander removed per request; remaining payment types BBVA and Banorte retained */}
            </div>
        </div>
    );
};

const ImageSlider = ({ images, ribbonUrl }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearTimeout(timer);
  }, [currentIndex, images.length]);

  return (
    <div className="relative w-full max-w-4xl mx-auto h-64 md:h-96 rounded-lg shadow-2xl">
      <div className="absolute inset-0 overflow-hidden rounded-lg">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Prize image ${index + 1}`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
              index === currentIndex ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
      </div>
      <img
        src={ribbonUrl}
        alt="Moño de Regalo"
        className="absolute -top-4 -right-4 w-28 h-28 md:w-36 md:h-36 object-contain z-10"
      />
    </div>



 


  );
};

const Rating = () => (
    <section className="py-16 bg-gray-50">
    <div className="container mx-auto text-center px-4">
        

        {/* --- AVISO DE FECHA DEL SORTEO (OPCIÓN 2) --- */}
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-green-100 max-w-3xl mx-auto transform transition-all hover:shadow-md">
            <h3 className="text-xl font-bold text-green-700 mb-3">¡AYÚDANOS A AYUDAR!</h3>
            <p className="text-gray-600 leading-relaxed">
                Al ser un sorteo con causa, necesitamos recaudar fondos suficientes para cumplir nuestra misión.
                Por ello, la fecha del gran sorteo se definirá al completar el <span className="font-bold text-green-700 bg-green-50 px-1 rounded">75% de la venta de boletos</span>.
                ¡Gracias por ser parte de este esfuerzo!
            </p>
        </div>
    </div>
</section>
);


const TechSheetViewer = ({ pdfUrl, onClose }) => (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-[60] flex flex-col justify-end" onClick={onClose}>
        <div className="bg-white w-full h-[90%] rounded-t-2xl p-4 flex flex-col animate-slide-in-up" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-2">
                <h3 className="font-bold text-black">Ficha Técnica - {CONFIG.prizeName}</h3>
                <button onClick={onClose} className="text-gray-500 hover:text-black"><CloseIcon className="w-6 h-6" /></button>
            </div>
            <iframe src={pdfUrl} className="w-full h-full border-0" title="Ficha Técnica"></iframe>
        </div>
    </div>
);

const SystemStatus = () => (
    <div className="fixed bottom-4 left-4 z-50">
       <div className="flex items-center gap-3 p-3 bg-white/50 backdrop-blur-md rounded-full shadow-lg border border-white/20">
           <div className="relative w-3 h-3 flex items-center justify-center">
               <div className="w-full h-full bg-green-400 rounded-full animate-ping"></div>
               <div className="absolute inset-0 w-full h-full bg-green-500 rounded-full border-2 border-white"></div>
           </div>
           <span className="font-semibold text-black text-sm hidden sm:inline">Todos los sistemas funcionando</span>
       </div>
   </div>
);


const CharityBanner = () => (
    <section className="py-12 bg-white">
        <div className="container mx-auto text-center flex flex-col md:flex-row items-center justify-center gap-6 px-4">
            <img src={CONFIG.charity.logoUrl} alt={CONFIG.charity.name} className="h-24 object-contain"/>
            <div>
                 <h3 className="text-2xl font-bold text-black">¡Tu compra tiene causa!</h3>
                 <p className="text-gray-600">Con cada boleto que adquieres, apoyas a la <span className="font-semibold">{CONFIG.charity.name}</span>.</p>
            </div>
        </div>
    </section>
);

const AboutUs = () => (
    <section id="about" className="py-16 bg-white">
        <div className="container mx-auto text-center px-4">
            <h2 className="text-3xl font-bold text-black mb-4">ACERCA DE NOSOTROS</h2>
            <p className="text-xl font-semibold text-green-600 mb-6 uppercase">Comunidad de personas sin miedo al éxito</p>
            <div className="max-w-3xl mx-auto text-gray-700 space-y-4">
                <p>
                    <span className="font-bold">Rifas, sorteos combos y más</span> trabajando desde 2025.
                </p>
                <p>
                    <span className="font-bold">Ubicados en Leon, Guanajuato. </span>
                </p>
                <p className="font-bold text-lg">
                    ¡ANÍMATE A PARTICIPAR Y GANAR, LOS MEJORES SORTEOS ESTÁN AQUÍ!
                </p>
                <p>
                    Puedes participar desde cualquier parte de México y Estados Unidos. Todos nuestros sorteos se realizan de forma segura y transparente en base a los números ganadores de la Lotería Nacional y con transmisión en vivo.
                </p>
            </div>
        </div>
    </section>
);

const FaqSection = ({ faqs }) => {
    const [openFaq, setOpenFaq] = useState(null);

    return (
        <section id="faq" className="py-16 bg-gray-50">
            <div className="container mx-auto px-4">
                <h2 className="text-3xl font-bold text-center text-black mb-10">PREGUNTAS FRECUENTES</h2>
                <div className="max-w-3xl mx-auto space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg bg-white shadow-sm">
                            <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full text-left p-5 flex justify-between items-center font-semibold text-black hover:bg-gray-50 transition-colors">
                                <span>{faq.question}</span>
                                <span className="text-xl text-green-500">{openFaq === index ? '−' : '+'}</span>
                            </button>
                            {openFaq === index && (
                                <div className="p-5 border-t text-gray-700">
                                    <p dangerouslySetInnerHTML={{ __html: faq.answer.replace(/\n/g, '<br />') }} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};


const TicketVerifier = () => { return null };

const Footer = ({ onShowPrivacy }) => (
    <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto text-center px-4">
            <h3 className="text-2xl font-bold mb-4">CONTÁCTANOS</h3>
            <p className="mb-4 text-gray-300">¿Tienes dudas? ¡Estamos para ayudarte!</p>
            <a href={`https://wa.me/${CONFIG.whatsappNumber}?text=Hola,%20necesito%20ayuda%20con%20la%20rifa.`}
               target="_blank"
               rel="noopener noreferrer"
               className="inline-flex items-center gap-3 bg-green-500 text-white font-bold py-3 px-6 rounded-full hover:bg-green-600 transition-all transform hover:scale-105">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.886-.001 2.269.654 4.388 1.849 6.22l-1.03 3.766 3.844-1.021z" /></svg>
                <span>PREGUNTAS POR WHATSAPP</span>
            </a>
            <p className="mt-4 font-semibold">(52) 477 923 13 72</p>
            <div className="mt-10 border-t border-gray-700 pt-6">
                <button onClick={onShowPrivacy} className="hover:text-green-400 transition-colors">
                    Aviso de Privacidad
                </button>
                <p className="text-sm text-gray-400 mt-4">
                    &copy; {new Date().getFullYear()} {CONFIG.companyName}. Todos los derechos reservados.
                </p>
            </div>
        </div>
    </footer>
);

// --- COMPONENTE PRINCIPAL ---
export default function App() {
    const [currentView, setCurrentView] = useState('home');
    const [reservationData, setReservationData] = useState(null); // 2. ESTADO PARA GUARDAR DATOS DE BOLETOS
    const [showPdf, setShowPdf] = useState(false);
    const [showConfetti, setShowConfetti] = useState(false);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [firebaseUser, setFirebaseUser] = useState(null);
     

    useEffect(() => {
        const updateDimensions = () => {
            setDimensions({ width: window.innerWidth, height: window.innerHeight });
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        triggerConfetti();
        // Autenticación anónima obligatoria
        const auth = getAuth();
        signInAnonymously(auth)
            .catch((error) => {
                console.error('Error en signInAnonymously:', error);
                alert('Error de autenticación Firebase: ' + error.message);
            });
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setFirebaseUser(user);
        });
        return () => {
            window.removeEventListener('resize', updateDimensions);
            unsubscribe();
        };
    }, []);

    const triggerConfetti = () => {
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 5000);
    };

    const showHome = () => setCurrentView('home');
    const showPayment = () => setCurrentView('payment');
    const showTickets = () => setCurrentView('boletos');
    const showPrivacy = () => setCurrentView('privacy');
    const showVerifier = () => setCurrentView('verificador');

    // 3. FUNCIÓN PARA NAVEGAR A LA PANTALLA DE REGISTRO
    const handleGoToRegister = (data) => {
        setReservationData(data);
        setCurrentView('registro');
    };

    // 4. FUNCIÓN PARA CONFIRMAR Y GUARDAR LA RESERVACIÓN EN FIREBASE
    const handleConfirmRegistration = async (formData) => {
        if (!firebaseUser) {
            alert('No hay usuario autenticado en Firebase. Intenta de nuevo en unos segundos.');
            return;
        }
        if (!reservationData || reservationData.selectedTicketNumbers.length === 0) {
            console.error("No hay boletos seleccionados para registrar.");
            alert("No hay boletos seleccionados para registrar.");
            return;
        }
        try {
            const reservationsCol = collection(db, `artifacts/${appId}/public/data/reservations`);
            let result;
            if (reservationData.reservationId) {
                const reservationDocRef = doc(db, `artifacts/${appId}/public/data/reservations`, reservationData.reservationId);
                result = await updateDoc(reservationDocRef, {
                    name: formData.name,
                    phone: formData.phone,
                    state: formData.state,
                    municipio: formData.municipio,
                    tickets: reservationData.selectedTicketNumbers,
                    updatedAt: serverTimestamp(),
                    confirmed: true
                });
                console.log('Reservación actualizada:', reservationData.reservationId);
            } else {
                const docRef = await addDoc(reservationsCol, {
                    name: formData.name,
                    phone: formData.phone,
                    state: formData.state,
                    municipio: formData.municipio,
                    tickets: reservationData.selectedTicketNumbers,
                    createdAt: serverTimestamp()
                });
                console.log('Reservación creada:', docRef.id);
                alert('Reservación creada correctamente. ID: ' + docRef.id);
            }
            triggerConfetti();
            return true;
        } catch (error) {
            console.error("Error al guardar la reservación:", error);
            alert('Error al guardar la reservación: ' + error.message);
        }
    };


    const scrollToSection = (sectionId) => {
        if (currentView !== 'home') {
            showHome();
            setTimeout(() => { document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' }); }, 100);
        } else {
            document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
        }
    };
    
    return (
        <div className="bg-white min-h-screen font-sans text-black">
            {showConfetti && (
                <Confetti
                    width={dimensions.width}
                    height={dimensions.height}
                    recycle={false}
                    numberOfPieces={400}
                    gravity={0.15}
                    style={{ zIndex: 100 }}
                />
            )}
            <style>{`
              @keyframes fade-in-down { 0% { opacity: 0; transform: translateY(-20px); } 100% { opacity: 1; transform: translateY(0); } }
              @keyframes slide-in-up { 0% { transform: translateY(100%); } 100% { transform: translateY(0); } }
              .animate-fade-in-down { animation: fade-in-down 0.3s ease-out; }
              .animate-slide-in-up { animation: slide-in-up 0.9s ease-out; }
              @keyframes gentle-bounce {
                0%, 100% { transform: translateY(0) scale(1); }
                50% { transform: translateY(-8px) scale(1.05); }
              }
              .animate-gentle-bounce {
                animation: gentle-bounce 2s infinite cubic-bezier(0.4, 0, 0.2, 1);
              }
            `}</style>
            
            {/* MODIFICACIÓN 3: Pasamos la función 'showVerifier' al componente Header. */}
            <Header 
                onShowPayment={showPayment} 
                onShowTickets={showTickets} 
                scrollToSection={scrollToSection}
                onShowVerifier={showVerifier} 
            />
     <main id="home" className="pt-32 pb-16">
  <div className="text-center p-4">
    
    <div className="max-w-5xl mx-auto relative group">
      <div className="absolute -inset-1 bg-gradient-to-r from-green-600 via-cyan-500 to-blue-600 rounded-2xl blur-lg opacity-75 group-hover:opacity-100 transition duration-1000 animate-[spin_20s_linear_infinite]"></div>

      <div className="relative bg-white rounded-2xl shadow-2xl p-6 md:p-10 ring-1 ring-gray-900/5" style={{
          backgroundImage: `
            linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)),
            linear-gradient(45deg, #f0f4f8 25%, transparent 25%),
            linear-gradient(-45deg, #f0f4f8 25%, transparent 25%),
            linear-gradient(45deg, transparent 75%, #f0f4f8 75%),
            linear-gradient(-45deg, transparent 75%, #f0f4f8 75%)`,
          backgroundSize: '20px 20px, 20px 20px, 20px 20px, 20px 20px, 20px 20px',
          backgroundPosition: '0 0, 10px 0, 10px -10px, 0px 10px, 0px 0px'
      }}>
        <div className="relative z-10">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-gradient-to-r from-gray-800 to-black text-white font-semibold text-sm shadow-lg group-hover:scale-105 transition-transform duration-300">
            ✨ EDICIÓN #{CONFIG.eventNumber} – ¡Tu oportunidad de ganar!
          </div>

          <h1 className="text-5xl md:text-6xl font-black mb-3 text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-600 drop-shadow-lg">
            Nissan Versa & Aveo HB ¡Aprovecha esta gran oportunidad!
          </h1>

          <p className="text-lg md:text-xl text-gray-600 mb-8 drop-shadow-sm">
            El auto de tus sueños podría ser tuyo por solo <span className="font-bold text-gray-800">$20 MXN 🎟️</span>.
          </p>
            <button onClick={() => { vibrateOnClick(); showTickets(); }} className="bg-green-500 text-white font-bold py-2 px-8 rounded-full text-lg hover:bg-green-600 transition-shadow shadow-lg hover:shadow-xl inline-flex items-center gap-2 animate-gentle-bounce">
                           Comprar Boletos <TicketIcon size={20} />
                       </button>
            
        </div>
      </div>
    </div>
  
                    <div className="mt-8">
                        <ImageSlider images={CONFIG.prizeImages} ribbonUrl={CONFIG.ribbonUrl} />
                    </div>
                    <div className="my-8 flex flex-col items-center gap-4">
                         <p className="text-gray-600 mt-6 max-w-2xl mx-auto">
                ¡Adquiere tus boletos ahora mismo, recuerda enviar el comprobante de pago a nuestro whatsapp autorizado (4779231372) incluyendo tu nombre completo como referencia. 
            </p>
            <h3 className="text-2xl font-bold text-black">¡Te deseamos mucha suerte!</h3>
                        <button onClick={() => { vibrateOnClick(); showTickets(); }} className="bg-green-500 text-white font-bold py-3 px-8 rounded-full text-lg hover:bg-green-600 transition-shadow shadow-lg hover:shadow-xl inline-flex items-center gap-2 animate-gentle-bounce">
                           Comprar Boletos <TicketIcon size={20} />
                       </button>
                     </div>
                </div>
                <CharityBanner />
                <Rating />
                <AboutUs />
                <FaqSection faqs={CONFIG.faqs} />
            </main>
            
            <SystemStatus />

            {currentView === 'payment' && <PaymentMethods onBack={showHome} />}
            
            {/* 5. PASAMOS LA FUNCIÓN DE NAVEGACIÓN A BOLETOS.JS */}
            {currentView === 'boletos' && <Boletos onBack={showHome} onGoToRegister={handleGoToRegister} CONFIG={CONFIG} />}
            {/* Verificador: sólo visible en Home para evitar solapamiento con la vista de boletos/registro */}
            {currentView === 'home' && <Verificador onBack={showHome} />}

            {/* 6. RENDERIZAMOS LA VISTA DE REGISTRO CUANDO SEA NECESARIO */}
            {currentView === 'registro' && reservationData && (
                <Registro 
                    selectedCount={reservationData.selectedTicketNumbers.length}
                    selectedTicketNumbers={reservationData.selectedTicketNumbers}
                    onClose={() => setCurrentView('boletos')} // Regresa a la selección de boletos
                    onConfirm={handleConfirmRegistration}
                    expirationHours={CONFIG.minutesToRelease / 1}
                />
            )}

            {currentView === 'privacy' && <AvisoDePrivacidad onBack={showHome} />}
            
            {showPdf && <TechSheetViewer pdfUrl={CONFIG.pdfUrl} onClose={() => setShowPdf(false)} />}
            
            <Footer onShowPrivacy={showPrivacy} />
        </div>
    );
}
